import { useEffect } from 'react';
import { useRouter } from 'next/compat/router';
import { useCurrentClientData } from '@pass-frontend/common/data-bridge';
import { env } from '@pass-frontend/features/configuration/util';

const { FF_ENABLE_CLIENT_PORTAL } = env();

export const useClientLoginCheck = () => {
  const router = useRouter();

  const isClientPage =
    router?.pathname !== undefined &&
    router?.pathname.split('/')[1] === 'client';

  const { isClientAuthenticated, loading, clientName } = useCurrentClientData();
  useEffect(() => {
    if (isClientPage && !FF_ENABLE_CLIENT_PORTAL) {
      router?.push('/'); // redirect to home page if client reports are disabled
    }
    // if user is unauthenticated and path needs them to re-login, redirect to login page
    if (isClientPage && !isClientAuthenticated && !loading) {
      router?.push('/client');
    }
  }, [isClientAuthenticated, loading, isClientPage]);

  return {
    isClientPage,
    loading,
    isClientAuthenticated,
    clientName,
  };
};
